/**
 * Si quien ha iniciado sesion administra la plataforma.
 *
 * Sirve para dos cosas: ensenarle el acceso al panel, y no
 * ensenarselo a quien no lo es. La proteccion de verdad esta en la
 * base de datos, donde cada funcion comprueba is_admin() por su
 * cuenta; esto es para que la interfaz no ofrezca lo que no puede
 * hacerse.
 */

import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/contexts/AuthContext'
import { getSupabase, isSupabaseEnabled } from '@/lib/supabase'

async function fetchIsAdmin(): Promise<boolean> {
  if (!isSupabaseEnabled()) return false
  const supabase = getSupabase()
  if (!supabase) return false

  const { data, error } = await supabase.rpc('is_admin')
  if (error) {
    console.info('[isAdmin]', error.message)
    return false
  }
  return data === true
}

export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
  const { user } = useAuth()

  const { data = false, isLoading } = useQuery({
    queryKey: ['is-admin', user?.id],
    queryFn: fetchIsAdmin,
    enabled: Boolean(user?.id),
    // No cambia dentro de una sesion
    staleTime: 30 * 60 * 1000,
  })

  return { isAdmin: data, isLoading }
}
